import createWebIcon from "../createWebIcon";
import type { IconProps } from "../Icon.props";
import validateKeys from "../validateKeys";

export default function Location({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <Location.Outline {...props} />
  ) : (
    <Location.Solid {...props} />
  );
}

Location.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 2.25C8.27208 2.25 5.25 5.27208 5.25 9C5.25 11.7679 6.76705 14.4443 8.46064 16.5395C9.31549 17.5972 10.1988 18.4963 10.8846 19.1419C11.2273 19.4646 11.5218 19.7256 11.7417 19.9121C11.8516 20.0053 11.9423 20.0797 12 20.131C12.0577 20.0797 12.1484 20.0053 12.2583 19.9121C12.4782 19.7256 12.7727 19.4646 13.1154 19.1419C13.8012 18.4963 14.6845 17.5972 15.5394 16.5395C17.233 14.4443 18.75 11.7679 18.75 9C18.75 5.27208 15.7279 2.25 12 2.25ZM12 21C11.4854 21.6432 11.485 21.6429 11.4846 21.6425L11.4812 21.64L11.4736 21.6339L11.4474 21.6131C11.425 21.5952 11.3929 21.5693 11.3516 21.5358C11.2692 21.4688 11.1519 21.372 11.0057 21.2479C10.7135 21.0001 10.3024 20.6413 9.81662 20.1831C8.84558 19.2678 7.57826 18.0028 6.38936 16.5293C4.01982 13.5932 3.75 10.3571 3.75 9C3.75 4.44365 7.44365 0.75 12 0.75C16.5563 0.75 20.25 4.44365 20.25 9C20.25 10.3571 19.9802 13.5932 17.6106 16.5293C16.4217 18.0028 15.1544 19.2678 14.1834 20.1831C13.6976 20.6413 13.2865 21.0001 12.9943 21.2479C12.8481 21.372 12.7308 21.4688 12.6484 21.5358C12.6071 21.5693 12.575 21.5952 12.5526 21.6131L12.5264 21.6339L12.5188 21.64L12.5162 21.642C12.5158 21.6424 12.5146 21.6432 12 21ZM12 21L12.5146 21.6432C12.2087 21.8805 11.7909 21.8802 11.4854 21.6432L12 21Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 7.25C10.7574 7.25 9.75 8.25736 9.75 9.5C9.75 10.7426 10.7574 11.75 12 11.75C13.2426 11.75 14.25 10.7426 14.25 9.5C14.25 8.25736 13.2426 7.25 12 7.25ZM8.25 9.5C8.25 7.42893 9.92893 5.75 12 5.75C14.0711 5.75 15.75 7.42893 15.75 9.5C15.75 11.5711 14.0711 13.25 12 13.25C9.92893 13.25 8.25 11.5711 8.25 9.5Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Location.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          d="M20.002 10.98C20.002 16.68 12.002 22 12.002 22C12.002 22 4.00195 16.68 4.00195 10.98C4.00195 8.86357 4.84481 6.83383 6.3451 5.33729C7.84539 3.84075 9.88022 3 12.002 3C14.1237 3 16.1585 3.84075 17.6588 5.33729C19.1591 6.83383 20.002 8.86357 20.002 10.98Z"
          className="icon-secondary"
        />
        <path
          d="M12.0039 15.002C14.213 15.002 16.0039 13.2111 16.0039 11.002C16.0039 8.79281 14.213 7.00195 12.0039 7.00195C9.79477 7.00195 8.00391 8.79281 8.00391 11.002C8.00391 13.2111 9.79477 15.002 12.0039 15.002Z"
          className="icon-primary"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
